<template lang="pug">
.event-card(:class="active? 'active': ''" @click="onClick")
  blue-shadow  
  .card(ref="card")
    .banner
      .cover(:style="`background-image: url(${evt.cover})`")
      .hero(:style="`background-image: url(${evt.banner})`")
    .content
      .copy
        //- .title {{evt.title}}
        //- .date {{evt.date}}
      .btn-more 查看详情
    //.body-wrapper
    .body
      .title(v-html="evt.title")
      //rich-text
      rich-text2(:content="evt.content")

  
</template>
<script>
import { mapGetters } from 'vuex'
import gsap from 'gsap'
import BlueShadow from '@/components/wedgits/BlueShadow'
import banner1 from '@/assets/banner1.png'
import banner2 from '@/assets/banner2.png'
import banner3 from '@/assets/banner3.png'
import RichText from '@/components/events/RichText'
import RichText2 from '@/components/events/RichText2'
export default {
  name: 'EventCard',
  components: { RichText2, RichText, BlueShadow },
  props: {
    active: {},
    idx: {},
    evt: {},
  },
  computed: {},
  data() {
    return {
      state: 0,
      clone: null,
      placeholders: [banner1, banner2, banner3],
    }
  },
  watch: {
    active(val) {
      if (val) {
        this.toState1()
      } else {
        this.toState0()
      }
    },
  },
  methods: {
    ...mapGetters('app', ['getSysBarHeight']),
    onClick() {
      this.$emit('clicked')
    },
    toState0() {
      this.clone.classList.remove('active')
      setTimeout(() => {
        gsap.to(this.clone, {
          width: this.rect.width,
          height: this.rect.height,
          x: 0,
          y: 0,
          duration: 0.3,
          ease: 'power3',
          onComplete: () => {
            this.$el.style.opacity = 1
            document.body.removeChild(this.clone)
            this.clone = null
          },
        })
      }, 10)
    },
    toState1() {
      this.clone = this.$refs.card.cloneNode(true)
      this.rect = this.$refs.card.getBoundingClientRect()
      this.sysTop = this.getSysBarHeight()
      this.clone.style.position = 'fixed'
      this.clone.style.zIndex = 999
      //this.clone.style.background = 'red'
      this.clone.style.top = this.rect.top + 'px'
      this.clone.style.left = this.rect.left + 'px'
      this.clone.style.width = this.rect.width + 'px'
      this.clone.style.height = this.rect.height + 'px'
      this.clone.addEventListener('click', this.onClick)
      document.body.appendChild(this.clone)
      //this.clone.classList.add('active')
      this.$el.style.opacity = 0
      gsap.to(this.clone, {
        width: window.innerWidth,
        height: window.innerHeight - this.sysTop,
        x: -this.rect.left,
        y: -this.rect.top + this.sysTop,
        duration: 0.5,
        ease: 'back.out(2)',
        onComplete: () => {},
      })
      setTimeout(() => {
        this.clone.classList.add('active')
      }, 10)
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "../../styles/common"
.event-card
  width: 100%
  height: 100%
  position: relative
.card
  width: 100%
  height: 100%
  border-radius: pxToRem(16)
  overflow: hidden
  box-shadow: 0 pxToRem(-1) pxToRem(10) 0 rgba(226,226,226,0.73)
  //transition: all 0.5s ease
  background: #ffffff
  display: flex
  flex-direction: column
  position: relative
  &.active
    border-radius: 0
    //display: flex
    //align-items: center
    //justify-content: center
    overflow-x: hidden
    overflow-y: scroll
    .content
      //opacity: 0
      //height: 0
      display: none
    .banner
      //position: relative
      //display: block
      //overflow: hidden
      height: 56.25vw
      width: 100vw
      //height: pxToRem(400)
      //background: #1664FF
      .cover
        height: 100%
        width: 100%
      .hero
        //position: relative
        opacity: 1
    .body
      display: block
  .banner
    width: 100%
    height: 100%
    //max-height: pxToRem(500)
    //background: #1664FF
    //overflow: hidden
    //display: flex
    //align-items: center
    //justify-content: center
    position: relative
    //background: #1664FF
    .cover
      width: 100%
      height: 100%
      background-position: center
      background-size: 100% 100%
    .hero
      transition: opacity 0.7s ease-out
      pointer-events: none
      opacity: 0
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      background-position: center
      background-size: 110% 110%
  .content
    //transition: all 0.2s $easeOutCubic
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    padding: pxToRem(40)
    display: flex
    justify-content: space-between
    align-items: flex-start
    flex-direction: column
    .copy
      width: 100%
      .title
        color: #ffffff
        font-size: pxToRem(36)
      .date
        color: #ffffff
        font-size: pxToRem(24)
    .btn-more
      //position: relative
      //z-index: 999
      width: pxToRem(152)
      height: pxToRem(53)
      border-radius: pxToRem(26.5)
      background: #ffffff
      color: $cl-blue
      font-size: pxToRem(26)
      line-height: pxToRem(53)
      text-align: center
  //.body-wrapper
    //background: yellow
    width: 100%
    flex: 1
    overflow-x: hidden
    overflow-y: scroll
    transform-origin: center
    animation-name: fadeIn
    animation-fill-mode: both
    animation-duration: 0.3s
    animation-delay: 0.2s
    animation-timing-function: ease
    -webkit-overflow-scrolling: touch
  .body
    //padding-top: pxToRem(80)
    display: none
    width: 100%
    padding: pxToRem(80) pxToRem(40)
    .title
      color: black
      font-size: pxToRem(54)
      line-height: pxToRem(75)
      margin-bottom: pxToRem(40)

    //.copy
      width: 100%
      .title
        color: black
        font-size: pxToRem(54)
        line-height: pxToRem(75)
        margin-bottom: pxToRem(40)
      .date
        color: black
        font-size: pxToRem(30)
    //.summary
      margin-top: pxToRem(40)
      font-size: pxToRem(30)
      line-height: pxToRem(50)
      color: #999999
      width: 100%

@keyframes fadeIn
  0%
    transform: translateY(10%)
    opacity: 0
  100%
    transform: translateY(0)
    opacity: 1
</style>
